import { RankingQuery } from "../enums/ranking-query";
import { Guid } from "../types/guid";

export class RankingCriteria {
  span?: RankingQuery.Span;
  organization?: Guid;
  course?: Guid;
  group?: Guid;
  page: number;
  page_size: number;

  constructor() {
    this.page = 0;
    this.page_size = 10;
    this.span = RankingQuery.Span.all;

    this.organization = undefined;
    this.course = undefined;
    this.group = undefined;
  }
}
